<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed'],

	computed: {

		value: function() {

			if (!this.item.play) return '-'
			if (!this.item.play.result) return 'Untracked'
			return this.item.play.won ? 'Win' : 'Loss'

		}

	}

}

</script>
